module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2001551c7cc77426db3bb692d9bb3c7a.png";